import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) { }

	canActivate(): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
		if (!this.authService.verificateAuthentication()) {
			return this.router.parseUrl('/login?redirect=' + encodeURIComponent(this.router.url));
		} else {
			return true;
		}
	}
}